import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from 'reactstrap'
import React from 'react'
import * as yup from 'yup'
import { useFormik } from 'formik'

// @components
import { FileUpload } from 'components/FileUpload/FileUpload'

// @hooks
import { useGrupoInteres } from 'hooks/useGrupoInteres'
import { usePeraca } from 'hooks/usePeraca'
import { useCargaGI } from 'hooks/useCargasGI'

// @utils
import { getExtension } from 'utils/archivos'

// @constants
import { EXTESIONES_SOPORTADAS } from './constants'

const cargaDatosSchema = yup.object().shape({
  grupo_interes: yup.number().required('Este campo es requerido'),
  archivo: yup
    .mixed()
    .required('Seleccione un archivo')
    .test('name', 'Extension no soportada', (file) =>
      EXTESIONES_SOPORTADAS.includes(getExtension(file?.name)),
    ),
  peraca: yup.number().required('Seleccione periodo academico'),
  estado: yup.string(),
})

const initialValues = {
  grupo_interes: '',
  archivo: null,
  peraca: '',
  estado: 'Pendiente',
}

export const ModalCargarDatos = ({ data, open, onToggle, onClosedModal }) => {
  /**
   * Consultas
   */
  const { obtenerGruposInteres } = useGrupoInteres()
  const { data: gruposInteres } = obtenerGruposInteres('')
  const { obtenerPeracas } = usePeraca()
  const { data: peracas } = obtenerPeracas('')
  const { handleCrearCargaGI, handleActualizarCargaGI } = useCargaGI(onToggle)

  const {
    handleChange,
    values,
    handleSubmit,
    errors,
    dirty,
    isValid,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: cargaDatosSchema,
    initialValues: {
      ...data,
      ...initialValues,
      grupo_interes: data?.grupo_interes?.id || '',
    },
    onSubmit: async (values, acciones) => {
      if (data?.id) {
        handleActualizarCargaGI({ values, acciones, id: data.id })
      } else {
        handleCrearCargaGI(values, acciones)
      }
    },
  })

  const puedeGuardar = dirty && isValid

  return (
    <Modal
      isOpen={open}
      toggle={onToggle}
      size='lg'
      unmountOnClose
      onClosed={onClosedModal}
    >
      <ModalHeader toggle={onToggle}>
        {data?.id ? 'Editar' : 'Crear'} carga de datos
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Entidad</Label>
                <Input
                  type='select'
                  name='grupo_interes'
                  value={values.grupo_interes}
                  onChange={handleChange}
                  placeholder='Ingrese grupo interes'
                  invalid={!!errors.grupo_interes}
                >
                  <option value={null}>Seleccione...</option>
                  {gruposInteres?.results?.map(({ id, nombre }, key) => (
                    <option key={key} value={id}>
                      {nombre}
                    </option>
                  ))}
                </Input>
                <div className='invalid-feedback'>{errors.grupo_interes}</div>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Periodo academico</Label>
                <Input
                  type='select'
                  name='peraca'
                  value={values.peraca}
                  onChange={handleChange}
                  placeholder='Ingrese periodo academico'
                  invalid={!!errors.peraca}
                >
                  <option value={null}>Seleccione...</option>
                  {peracas?.results?.map(({ id, peraca }, key) => (
                    <option key={key} value={id}>
                      {peraca}
                    </option>
                  ))}
                </Input>
                <div className='invalid-feedback'>{errors.peraca}</div>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label>Archivo</Label>
                <FileUpload
                  id='archivo'
                  name='archivo'
                  onChange={(event) =>
                    setFieldValue('archivo', event.currentTarget.files[0])
                  }
                  value={values.archivo}
                  invalid={!!errors.archivo}
                  error={errors.archivo}
                  accept={EXTESIONES_SOPORTADAS.join(',')}
                >
                  {values.archivo?.name}
                </FileUpload>
              </FormGroup>
            </Col>
          </Row>

          <Button color='primary' type='submit' disabled={!puedeGuardar}>
            Cargar datos
          </Button>
        </form>
      </ModalBody>
    </Modal>
  )
}
